import moment from 'moment';

export function formatDate(date, format = 'YYYY-MM-DD') {
    return moment(date).format(format);
}

export function formatTime(time, format = 'HH:mm:ss') {
    return moment(time).format(format);
}